import React from "react";
import {
  doctors,
  leaf,
  leaf2,
  mainLeaf,
  subDoc2,
  subDoc3,
  subDoc4,
  subDoc5,
  subDoc6,
  subDoc7,
  subDoc8,
  flower,
  subDoc1,
  shamim,
  excellence,
  focus,
  quality,
  care,
  insight,
  simplicity,
  passion,
  teamWork,
} from "../../assets";
import Slider from "react-slick";
import DoctorCard from "../../Components/DoctorCard";
import Hours from "../Home/Hours";
import { motion } from "framer-motion";

const AboutUsPage = ({
  doc,
  main,
  name,
  edu,
  spe,
  exp,
  desc1,
  desc2,
  highlight,
  sp1,
  sp2,
  sp3,
  setSingleDoc,
  adSub,
  adLoc,
}) => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <div id="aboutUsPage">
      <img src={mainLeaf} alt="" className="mainLeaf" />
      <img src={flower} alt="" className="mainLeaf2" />
      <img src={leaf2} alt="" className="mainLeaf3" />
      <img src={mainLeaf} alt="" className="mainLeaf4" />

      <motion.div
        className="milestone"
        whileInView={{ opacity: [0, 1], y: [-50, 0] }}
        transition={{ duration: 0.7 }}
      >
        <img src={leaf2} alt="" className="leaf" />
        <div className="bottom">
          <div className="dateTime">
            <div>
              <div className="ball"></div>
              <h2>2010</h2>
              <p>THE JOURNEY BEGINS</p>
              <small>
                As the only ‘Beautycinology Clinic’ of the country, Laser Treat
                starts operating with an investment of BDT 100 million.
              </small>
            </div>
            <div>
              <div className="ball"></div>

              <h2>2011</h2>
              <p>APPLIANCE RECOGNIZED</p>
              <small>
                The first Aesthetic Laser treatment Centre of Bangladesh with
                the global standard recognition of ‘ISO 9001:2008’.
              </small>
            </div>
            <div>
              <div className="ball"></div>

              <h2>2012</h2>
              <p>FUTURISTIC TECHNOLOGY</p>
              <small>
                Introduced ZERONA R in Bangladesh, the only non-surgical Fat
                Reduction Laser Technology with FDA Approval for ‘No
                Side-Effect’.
              </small>
            </div>
            <div>
              <div className="ball"></div>

              <h2>2019</h2>
              <p>STEPPED INTO OWN PREMISE</p>
              <small>
                Assembling & partnering the best Brands of the World in its own
                premise of the State-of-Art Clinic, Lasertreat stepped into its
                journey towards vision.
              </small>
            </div>
          </div>
        </div>
      </motion.div>

      <div className="about-text">
        <motion.div
          className="top-row"
          whileInView={{ opacity: [0, 1], x: [-50, 0] }}
          transition={{ duration: 0.7 }}
        >
          <div className="left-col">
            <img src={leaf} alt="" />

            <h1>
              With experience from our founder Dr. Sarker Mahbub Ahmed Shamim,
              the pioneer laser & aesthetic dermatologist of this subcontinent,
              we aim to redesign aesthetic dermatology by combining science,
              technology and the best patient care for you.
            </h1>
            <p>
              With more than 20 years of experience in Dermatology, Aesthetic
              dermatology, dermatosurgery, hair transplant, our doctors at laser
              treat understand your concerns when it comes to aesthetic
              services. At laser treat, we aim to deliver natural looking
              results with low down time in the hands of safe and experienced
              doctors. We understand the needs of our patients and strive to
              meet these expectations.
            </p>
            <p className="title">
              ISO Certified BEAUTYCINOLOGY clinic in Bangladesh
            </p>
          </div>
          <div className="right-col">
            <iframe
              src="https://www.youtube.com/embed/i11TceowUT0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen={true}
              className="banani"
            ></iframe>
          </div>
        </motion.div>
        <motion.div
          className="bottom-row"
          whileInView={{ opacity: [0, 1], x: [50, 0] }}
          transition={{ duration: 0.7 }}
        >
          <div className="left-col">
            <iframe
              src="https://www.youtube.com/embed/i11TceowUT0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen={true}
              className="banani"
            ></iframe>
          </div>
          <div className="right-col">
            <img src={leaf} alt="" />
            <h1>
              Beautycinology is a concept developed by scientists of laser
              treat, crafted by our engineers & physicians delight in
              conjunction with beauty, medicine & technology.
            </h1>
            <p>
              The laser treat was born to fulfil the needs and expectations of
              our patients. The most qualified dermatologists of laser treat,
              all of them have been trained specially from American Academy of
              Aesthetic Medicine. The clinic uses only the latest
              state-of-the-art equipment together with the best quality skincare
              products. We do not compromise on quality, yet we maintain very
              competitive prices. Conveniently located in The Banani 11 &
              Uttara.
            </p>
            <p className="title">We invite you to visit us soon</p>
          </div>
        </motion.div>
      </div>

      <div className="points">
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 0 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={excellence} alt="" className="cardLogo" />
          <h2>Excellence</h2>
          <p>
            Priorto Integrity and Respect, Excellence is the most popular core
            value at Lasertreat.
          </p>
        </motion.div>

        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={teamWork} alt="" className="cardLogo" />
          <h2>Team Work</h2>
          <p>
            Work as a team by helping each other and asking for help. Its harder
            than people think.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={passion} alt="" className="cardLogo" />
          <h2>Passion</h2>
          <p>
            At Lasertreat, We Innovate by trying new ways of applying things and
            improving every day.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 0.6 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={simplicity} alt="" className="cardLogo" />
          <h2>Simplicity</h2>
          <p>
            Strive to deliver the highest quality & value possible through
            simple, easy and relevant solutions.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 0.8 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={insight} alt="" className="cardLogo" />
          <h2>Insight</h2>
          <p>
            We set the standards by which individual and team performance are
            measured and rewarded.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 1 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={care} alt="" className="cardLogo" />
          <h2>Care</h2>
          <p>
            How we treat our clients, frame how we work with our associates, and
            are a key part of our ongoing success.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 1.2 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={quality} alt="" className="cardLogo" />
          <h2>Quality</h2>
          <p>
            ‘Quality’ or ‘performance’; the theme is always same; commitment to
            being the best and/or delivering the best.
          </p>
        </motion.div>
        <motion.div
          className="point"
          whileInView={{ opacity: [0, 1], x: [-20, 0] }}
          transition={{ duration: 0.7, delay: 1.4 }}
        >
          <img src={mainLeaf} alt="" className="XleafX" />
          <img src={focus} alt="" className="cardLogo" />
          <h2>Focus</h2>
          <p>We are very much focused; in our practice; towards our vision.</p>
        </motion.div>
      </div>

      <motion.div
        className="vision-mission"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <div className="vision">
          <img src={leaf} alt="" />
          <h2>Our Vision</h2>
          <p>
            To be one unified center for best reputed Aesthetic Treatment in
            Asia.
          </p>
        </div>
        <div className="banner">
          <img src={doctors} alt="" />
        </div>
        <div className="mission">
          <img src={leaf} alt="" />
          <h2>Our MIssion</h2>
          <p>
            Introduce the most integrated aesthetic treatment appliance with
            BEST RESULTS TO GO BEYOND the anticipation of our patients.
          </p>
        </div>
      </motion.div>

      <motion.div
        className="team"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <h1>Our Specialists</h1>
        <p className="p">
          We always provide the best and quality service for you and your future
        </p>

        <Slider {...settings} className="slider">
          <div>
            <DoctorCard
              doc={shamim}
              name="DR. Sarker Mahbub Ahmed Shamim"
              edu="MBBS, Dip. Derm (Glasgow, UK)"
              spe="Aesthetic Medicine (USA), MCPS, FCPS (Dermatology)"
              setSingleDoc={setSingleDoc}
              main={true}
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc1}
              name="Dr. Dilruba Sharmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="She has wide experience in Aesthetic Dermatology and Laser Surgery more than 5 year.
                Her subspecialty of interest include laser, Dermatological Surgery. Cosmetic Dermatology, PRP. She regularly consult Acne, Melasma, Psoriasis, Eczema.
                She is a member of American Academy of Aesthetic Medicine (USA)
                She graduated from holy Family Medical College."
              desc2="She later Completed her post-graduation training in dermatology & venereology from. Shaheed Suhrawardy Medical College Hospital."
              highlight="Consultant of Laser Treat & Dhaka Dermatology Institute"
              sp1="Dermatological Surgery"
              sp2="Cosmetic Dermatology"
              sp3="PRP"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc2}
              name="Dr. Rabeya Afroz Shoma"
              edu="MBBS, DDV (BSMMU)"
              spe="Skin, Sex & Anti-aging Specialist, Laser & Cosmetic Surgeon"
              setSingleDoc={setSingleDoc}
              exp="8"
              desc1="Dr. Rabeya Afroz Shoma has got her MBBS from Cumilla Medical College. She obtained her DDV from BSMMU in the year 2014.
                Dr. Rabeya has got vast experience in the management of general & aesthetic dermatology. She is been with Dr. Shamim & laser treat for the last 6 years. She has completed aesthetic training from American Academy of Aesthetic Medicine (AAAM)
                Besides these she has also attended many national & international conferences of dermatology & Aesthetic Medicine."
              desc2="She strives to provide the most advanced & personalized care to all her patients.
                Special Interest: BOTOX, FILLER, PRP, Vitiligo Surgery, Treating Scars, Hair Loss, Pigmentation, Genital & Vulvar Itching, Vulvar Tightening, Sex Counselling, O-Shot, P-Shot"
              adSub="Laser"
              adLoc="USA, Thailand, India"
              highlight="Core Member"
              sp1="Skin"
              sp2="Sex & Anti-aging"
              sp3="Laser & Cosmetic"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc3}
              name="Dr. Salma Sumi"
              edu="BSC, MSC (Food & Nutrition)"
              spe="Body Shaping & Weight management of Laser Treat"
              setSingleDoc={setSingleDoc}
              exp="5"
              desc1="Ms. Salma Sumi has got her B.Sc (Hons) in Food & Nutrition from College of Home Economics, University of Dhaka in 2012. She obtained her M.Sc from University of Dhaka in the year 2015.
                Ms. Salma Sumi has got more than 4 years’ experience in Nutrition & Dietetics. In 2015, she attended in-patient & out-patient departments during her training period In BSMMU & BIRDEM General Hospital. She has Advanced training in “Dietetics & Nutrition Therapy”."
              desc2="She worked as a Trainee Dietitian in United Hospital Limited, Dhaka. Besides these she has also taken part in various Nutrition & Dietetics programs.
                Special Interest: CoolSculpting, Zerona, Proslimelt, CLATUU, Lipolytic Mesotherapy
                As an experienced Nutritionist and body Shaping Consultant, Ms. Salma Sumi will guide you expertly through your Body shaping Journey."
              sp1="Body Shaping"
              sp2="Weight management"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc4}
              name="Dr. Saymun Jesmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. Saymun Jesmin attained her MBBS degree from Mymensingh Medical College in 2008.She went on to pursue her post-graduation training in Dermatology and Internal medicine. In 2014, she passed FCPS part-1.She had completed advanced aesthetic training from American Academy of Aesthetic Medicine (USA).
                Dr. Saymun has more than 9 years of experience in aesthetic medicine.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Acne, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, PRP, Q-Switched Nd:YAG Laser, HIFU, NBUVB, Hydra facial, IPL, Subcision, Body Shaping etc"
              sp1="Acne"
              sp2="Chemical Peeling"
              sp3="Hydra facial"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc5}
              name="Dr. Shamma Binte Hafiz"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="5"
              desc1="Dr. Shamma Binte Hafiz Heeya attained her MBBS degree from Delta Medical College in 2013.
                She is been with Dr. Shamim & Laser Treat for the last 5yrs. She has attended over 5000 patients during her training period. She has taken part in various CME programs.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Vitiligo Surgery, PRP, Treating Scars, Hair Loss, Pigmentation, Acne Treatment, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Vitiligo Surgery"
              sp2="Treating Scars"
              sp3="Hair Loss"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc6}
              name="Dr. Shumana Sharmin"
              edu="MBBS, DDV (BSMMU)"
              spe="Skin, Sex & Anti-aging Specialist, Laser & Cosmetic Surgeon"
              setSingleDoc={setSingleDoc}
              exp="8"
              desc1="Dr. Shumana Sharmin, who is a specialist dermatologist, cosmetologist & venereologist has passed out from holy family Red Crescent medical college hospital, Dhaka in year 2006. After that she took training in dermatology & venereology in different government hospitals in Bangladesh.
                In 2012 she pursued her post-graduation degree, DDV (Diploma in Dermatology & Venereology). She also took advance training in Aesthetic Medicine under American Academy of Aesthetic Medicine in 2019."
              desc2="She has an expertise in a variety of dermatological & cosmetic procedures including Chemical Peeling, Laser Hair Removal, CO2 Laser, Meso Therapy, Tattoo Removal, PRP, Fractional Laser, Subcision, IPL, HIFU, Hydrafacial etc.
                She has also attended some national & international conferences of dermatology & cosmetology."
              sp1="Skin"
              sp2="Sex & Anti-aging"
              sp3="Laser & Cosmetic"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc7}
              name="Dr. Sonia Sharmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. Sonia Sharmin attained her MBBS degree from shaheed Monsur Ali Medical College and hospital in 2018. Post graduation training from DMC.
                She has been with Dr. Shamim & Laser Treat for the last 2yrs. She has attended over 5000 patients during her training period. She has taken part in various CME programs.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Vitiligo Surgery, PRP, Treating Scars, Hair Loss, Pigmentation, Acne Treatment, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Pigmentation"
              sp2="Hair Loss"
              sp3="Acne Treatment"
            />
          </div>
          <div>
            <DoctorCard
              doc={subDoc8}
              name="Dr. A.S.M Raquibul Islam Akash"
              edu="	American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. A.S.M.Raquibul islam akash attained his MBBS degree from Dhaka University in 2016.He went on to pursue his post-graduation training in Dermatology and Internal medicine. 
                Dr. A.S.M Raquibul islam akash has more than 3years’ experience in clinical dermatology. He has attended over 10,000 patients in the out-patient and in-patient departments during his training period. He has taken part in various CME programs.
                He believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Acne, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, PRP, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Acne"
              sp2="PRP"
              sp3="Chemical Peeling"
            />
          </div>
        </Slider>
      </motion.div>

      <motion.div
        className="openTitle"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "0.5rem" }}>
          Opening Hours
        </h1>
        <p style={{ textAlign: "center", marginBottom: "3rem" }}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt,
          itaque.
        </p>
      </motion.div>

      <Hours />
    </div>
  );
};

export default AboutUsPage;
